import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from '../core/service'

export const getFilteredScoreRange = createAsyncThunk(
  'common/filterCompany/getFilteredScoreRange',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getFilteredScoreRange(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getProvinceVietNamese = createAsyncThunk(
  'common/filterCompany/getProvinceVietNamese',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getProvinceVietNam(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getVSIC = createAsyncThunk(
  'common/filterCompany/getVSIC',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getVSIC(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//searchPort
export const getSearchPortfolioInSetting = createAsyncThunk(
  'common/filterCompany/getSearchPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getSearchPortfolio(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
export const getSearchPortfolioAllInSetting = createAsyncThunk(
  'common/filterCompany/getSearchPortfolioAllInSetting',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getSearchPortfolio({
        pageSize: 300,
      })
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
//search exclude company
export const getSearchExcludeCompanyInPortfolio = createAsyncThunk(
  'common/filterCompany/getSearchExcludeCompanyInPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getSearchExcludeCompanyInPortfolio(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getFilteredCompaniesBusinessSize
export const getFilteredCompaniesBusinessSize = createAsyncThunk(
  'common/filterCompany/getFilteredCompaniesBusinessSize',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getFilteredCompaniesBusinessSize(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getFilteredCompaniesBusinessAge
export const getFilteredCompaniesBusinessAge = createAsyncThunk(
  'common/filterCompany/getFilteredCompaniesBusinessAge',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getFilteredCompaniesBusinessAge(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
//SaveSetting postSaveFilter
export const postSaveFilter = createAsyncThunk(
  'common/filterCompany/postSaveFilter',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.postSaveFilter(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getFilterDefault
export const getFilterDefault = createAsyncThunk(
  'common/filterCompany/getFilterDefault',
  async (params, { rejectWithValue, getState }) => {
    try {
      const response = await Service.getFilterDefault(params)
      if (response.success) {
        const allPortId = getState()?.[
          'common/filterCompany/portfolio'
        ]?.dataAllPortfolio?.map((i) => i.value)

        return { response: response.data, allPortId }
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getTotalCompanyBySettings
export const getTotalCompanyBySettings = createAsyncThunk(
  'common/filterCompany/getTotalCompanyBySettings',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTotalCompanyBySettings(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getCompanies
export const getCompanies = createAsyncThunk(
  'common/filterCompany/getCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getCompanies(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
